<template>
  <div class="warp">
    <navbarlogin :title="text"></navbarlogin>
    <div class="inner">
      <div class="person_box">
          <div class="inpititle">手机号</div>
          <input v-model="formdata.phoneNum" type="text" placeholder="请输入手机号">
      </div>
      <div class="person_box yanzheng">
        <div class="inpititle">验证码</div>
        <input  v-model="formdata.verCode" type="text" placeholder="请输入验证码" >
        <van-button  v-if="!canGetCode"
        class="yanzhengma"  
        data-appid="2032571166"
        data-cbfn="callback" 
        type="primary" 
        size="small">{{getCodePassTime}}</van-button>
        <van-button id="TencentCaptcha"
          v-else
          class="yanzhengma"  
          data-appid="2032571166"
          data-cbfn="callback" 
          type="primary" 
          size="small">获取验证码</van-button>
      </div>
      <div class="person_box">
        <div class="inpititle">昵称</div>
        <input v-model="formdata.nickName" type="text" placeholder="设置一个自己的昵称吧~">
      </div>
      <div class="person_box">
        <div class="inpititle">密码</div>
        <input v-model="formdata.password" type="password" placeholder="设置自己的账号密码">
      </div>
      <div class="person_box">
        <div class="inpititle">确认密码</div>
        <input v-model="formdata.rePassword" type="password" placeholder="再次输入密码以确认">
      </div>
      <van-loading v-if="load" type="spinner" />
      <div class="login_btn" @click="check">
        <van-button class="zhuce  loginbtn"  color="#64a5ff" size="16">注册</van-button>
      </div>
      <div class="top_zhuce" @click="godenglu">已有账号，去登录</div> 
    </div>
  </div>
</template>

<script>
import navbarlogin from './NavBarlogin'

import Vue from 'vue';
import { Button } from 'vant';
import { Notify } from 'vant';
import { Loading } from 'vant';

Vue.use(Loading);
Vue.use(Notify);
Vue.use(Button);

Vue.use(Button);
import { Swipe, SwipeItem } from 'vant';
import axios from 'axios'
Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  components:{
    navbarlogin
  },
  data () {
    return {
       formdata: {
          phoneNum: '',
          verCode:'',
          nickName:'',
          password: '',
          rePassword:'',
          fromuid:''
        },
        load:false,
          //是否可以获取验证码
        canGetCode:true,
        waitTime: 30,
        getCodePassTime:'获取验证码',
        text:'注册'
    }
  },
  mounted(){
    this.addVerJS();
    this.formdata.fromuid=localStorage.getItem('form_id')
  },
  methods:{
    goshouye(){
      this.$router.push({path:'/'})
    },

    godenglu(){
      this.$router.push({path:'/login'})
    },
       // 防水墙的验证
        addVerJS:function () {
            let that = this;
            const s = document.createElement('script');
            s.type = 'text/javascript';
            s.src = 'https://ssl.captcha.qq.com/TCaptcha.js';
            document.body.appendChild(s);
            console.log(s)
            window.callback = function (res) {
            console.log(res)
            if(res && res.ret === 0){
                console.log('验证通过')
                let params = {
                Ticket: res.ticket,
                Randstr: res.randstr,
                mobile: that.formdata.phoneNum
                }
                console.log(params)
                that.submitForm(params);
                this.load=false
            }
            }
        },
        //验证手机号并发送验证码
        async submitForm (params) {
            console.log('params',params)
            if (!params.mobile) {
            this.$notify("手机号不能为空");
             this.load=false
            return;
            }
            let reg=/^1[3456789]\d{9}$/;
            if (!reg.test(params.mobile)) {
            this.$notify('请输入正确的手机格式')
             this.load=false
            return;
            }
            axios.post(
            'http://api.rujiaowang.net/index.php/api/all/user_reg',
            params
            ).then(verCodeRes => {
            console.log(verCodeRes)
            //TODO 这里应该在判断成功里面
            this.canGetCode = false
            //   this.daojishi();
            if(verCodeRes.data.state===0) {
                this.$notify({
                  message: '验证码已发送',
                  color: '#9239db',
                  background: '#ffe1e1'
                })
                this.canGetCode = false
                this.daojishi();
            }else {
                this.$notify(verCodeRes.data.msg)
            }
            })
            .catch(error => {
                console.log(error.response)
            })

        },
        daojishi: function () {
            let that = this;
            if (this.waitTime === 0) {
            this.waitTime = 30;
            this.canGetCode = true;
            this.getCodePassTime = '获取验证码';
            } else {
            this.getCodePassTime = "重新发送(" + this.waitTime + ")"
            this.waitTime--;
            setTimeout(function() {
                that.daojishi()
                },
                1000)
            }
        },
        check: function(){
          this.load=true
            if (!this.formdata.phoneNum) {
              this.$notify("手机号不能为空");
               this.load=false
              return;
            }
            let reg=/^1[3456789]\d{9}$/;
            if (!reg.test(this.formdata.phoneNum)) {
              this.$notify('请输入正确的手机格式')
               this.load=false
              return;
            }
            if (this.formdata.nickName.length === 0) {
              this.$notify("请输入昵称");
               this.load=false
              return;
            }
            if (this.formdata.password.length === 0 || this.formdata.rePassword.length === 0){
              this.$notify("请输入密码");
               this.load=false
              return;
            }
            if(this.formdata.rePassword.length === 0){
              this.$notify("请再次输入密码");
               this.load=false
              return false;
            }
            if (this.formdata.password.length < 6
              || this.formdata.password.length > 11
              || this.formdata.rePassword.length < 6
              || this.formdata.rePassword.length > 11
            ) {
            this.$notify("密码位数应在6到11位");
             this.load=false
              return;
            }
            if(this.formdata.password !== this.formdata.rePassword) {
              this.$notify("两次次输入密码不一致");
               this.load=false
              return;
            }
            //注册
            this.signIn();
        },
        signIn:function () {
            var params= {
                mobile:this.formdata.phoneNum,
                code:this.formdata.verCode,
                name:this.formdata.nickName,
                password:this.formdata.password,
                fromuid:this.formdata.fromuid
            }
            console.log('这是注册需要的参数')
            console.log(params)
            let that = this
            axios.post ('http://api.rujiaowang.net/api/all/reg_type2',params)
            .then(function(regRes) {
                console.log(regRes)
                console.log(regRes.data.msg)
                that.load=false
                if (regRes.data.state===0) {
                    that.$notify(regRes.data.msg)
                    that.load=false
                    const regUserMsg = regRes.data.result
                    console.log(regUserMsg)
                    var userInfo = {}
                    userInfo.token = regUserMsg.token
                    console.log(userInfo)
                    that.load=false
                    localStorage.setItem("userInfo", JSON.stringify(userInfo))
                    localStorage.setItem("token", JSON.stringify(regUserMsg.token))
                    that.$router.push({
                        name:'login',
                        query:{
                        }
                    })
                }else {
                    that.$notify(regRes.data.msg)
                    that.load=false
                }
            })
            .catch (function(errRes) {
              console.log(errRes)
            })
        }
  }
}
</script>

<style scoped>
.person_box {
  margin-top: 20px;
  padding: 0 15px;
}
.inpititle{
  margin: 10px auto;
  color: #2f2f2f;
  font-size: 14px;
  text-indent: 30px;
}
.person_box input {
  line-height: 46px;
  width: 100%;
  outline: 0;
  border: 0;
  font-size: 15px;
  text-indent: 30px;
  border-radius: 15px;
  margin-bottom: 0;
  background: #f6f7f9;
}
.yanzheng{
  position: relative;
}
.yanzhengma{
  position: absolute;
  top: 70%;
  right: 0%;
  transform: translate(-50%,-50%);
}
.login_btn{
  text-align: center;
  padding: 25px 15px;
  line-height: 46px;
}
.van-button--primary /deep/ {
  background-color: rgb(100, 165, 255);
  border: 0.02667rem solid  rgb(100, 165, 255);
  border-radius: 23px;
}
.login_btn button{
  width: 100%;
  border-radius: 23px;
}
.top_zhuce {
  font-size: 16px;
  text-align: center;
  color: #007aff;
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue